<div fxLayout="column">
  <mat-card class="mat-card-inline-sm">
    <mat-card-content fxLayoutAlign="center center" fxLayout="column" fxLayout.lt-sm="column">
      <div *ngIf="!hideReport" class="w-100 m-b-20" fxLayout="row" fxLayoutAlign="end start">
        <button mat-flat-button color="accent" (click)="downloadCSV()">
          Export CSV
          <mat-icon>view_list</mat-icon>
        </button>
      </div>
      <mat-form-field>
        <input matInput type="text"
          [formControl]="searchReleaseIssuesField"
          (keyup)="doReleaseIssueFilter($event.target.value)"
          (keyup.esc)="$event.target.value=''; doReleaseIssueFilter('')"
          placeholder="Search all {{ filteredReleaseIssues?.length ?? 0 }} release issues">
      </mat-form-field>
    </mat-card-content>
  </mat-card>
  <div class="m-b-20 w-100" fxFlex="100">
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
      <small class="text-info"><i>filter:</i></small>
      <small *ngIf="priorityFilter === undefined &&
        statusFilter === undefined &&
        !createdFilter &&
        !assignedFilter &&
        !selectedReleaseIssue" class="text-warning">
        no filters currently applied
      </small>
      <mat-chip-list>
        <mat-chip *ngIf="priorityFilter !== undefined" color="accent">
          <span>Priority: {{ getPriority(priorityFilter) }}</span>
          <button matChipRemove>
            <mat-icon color="primary" matTooltip="Clear filter" (click)="onCardPriorityClick(undefined)">clear</mat-icon>
          </button>
        </mat-chip>
        <mat-chip *ngIf="statusFilter !== undefined" color="accent">
          <span>Status: {{ releaseIssueStatuses[statusFilter] }}</span>
          <button matChipRemove>
            <mat-icon color="primary" matTooltip="Clear filter" (click)="onCardStatusClick(undefined)">clear</mat-icon>
          </button>
        </mat-chip>
        <mat-chip *ngIf="createdFilter" color="accent">
          <span>Created By: {{ createdFilter }}</span>
          <button matChipRemove>
            <mat-icon color="primary" matTooltip="Clear filter" (click)="onCardCreatedClick(undefined)">clear</mat-icon>
          </button>
        </mat-chip>
        <mat-chip *ngIf="assignedFilter" color="accent">
          <span>Assigned To: {{ assignedFilter }}</span>
          <button matChipRemove>
            <mat-icon color="primary" matTooltip="Clear filter" (click)="onCardAssignedClick(undefined)">clear</mat-icon>
          </button>
        </mat-chip>
        <mat-chip *ngIf="selectedReleaseIssue" color="accent">
          <span>In focus Issue</span>
          <button matChipRemove>
            <mat-icon color="primary" matTooltip="Clear filter" (click)="clearFocusFilter()">clear</mat-icon>
          </button>
        </mat-chip>
      </mat-chip-list>
    </div>
  </div>
  <ng-container *ngFor="let item of filteredReleaseIssues; let i=index">
    <release-issue-card *ngIf="i < displayLength"
      [item]="item" 
      [hideEdit]="hideEdit"
      [searchTerm]="searchReleaseIssuesField?.value"
      [isSelectable]="isSelectable"
      [selectedCard]="selectedCard ?? selectedReleaseIssue"
      [productName]="productName"
      (onEdit)="onEdit($event)"
      (onSelectClick)="onCardSelectClick($event)"
      (onPriorityClick)="onCardPriorityClick($event)"
      (onStatusClick)="onCardStatusClick($event)"
      (onCreatedClick)="onCardCreatedClick($event)"
      (onAssignedClick)="onCardAssignedClick($event)"
      (onIssueLoadClick)="onCardIssueLoadClick($event)">
    </release-issue-card>
  </ng-container>
</div>